/* eslint-disable no-unused-vars */
export enum QueryKeys {
  Posts = 'posts',
  Comments = 'comments',
  Reactions = 'reactions',
  CommentAnswers = 'commentAnswers'
}
